import { render, staticRenderFns } from "./AddSlideTitle.vue?vue&type=template&id=159a2abd&scoped=true"
import script from "./AddSlideTitle.vue?vue&type=script&lang=js"
export * from "./AddSlideTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a2abd",
  null
  
)

export default component.exports